import axios from 'axios';
import router from '@/router';
import Clipboard from 'clipboard';
// import { Toast, Indicator } from 'mint-ui';
import { Toast} from 'vant';
import des from './des.js';
import md5 from 'js-md5';

// const fileserver = "https://file.caredaily.com";

var baseurl = process.env.VUE_APP_APIs;
var refresh_token_api = process.env.VUE_APP_APIs;

var FrontEnd = process.env.VUE_APP_FONTEND;

const service = axios.create({
	baseURL: baseurl,
	timeout: 300000
});

const d = 'Ckil845@#$%^_=258Lo{,.}';

service.interceptors.request.use(
	(config) => {
		// Indicator.open('加载中...');
		// if(config.url.indexOf('actmonitor')==-1){
		//     Indicator.open("加载中...")
		//   }
		if (sessionStorage.getItem('tokentwo')) {
			// 判断是否存在token，如果存在的话，则每个http header都加上token
			// config.headers.Authorization = JSON.parse(des.decryptByDES(sessionStorage.getItem('tokentwo'),d)).token;
			config.headers.Authorization = sessionStorage.getItem('tokentwo');
		}
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);

service.interceptors.response.use(
	(response) => {
		// Indicator.close();
		if (response.data && response.data.errmsg && response.data.errmsg == '系统维护中，请稍后再试') {
			router.push('/system');
		}
		return response;
	},
	(error) => {
		// Indicator.close();
		if (error.response.status == '401') {
			// router.push('/login')
			// let refreshData = {};
			// if (sessionStorage.getItem('refresh')) {
			// 	refreshData = {
			// 		refresh_token: des.decryptByDES(sessionStorage.getItem('refresh'), d)
			// 	};
			// }
			// service.post('http://192.168.80.20/usercenter/refresh', refreshData).then(res => {
			// 	if (res.data.ok) {
			// 		sessionStorage.setItem('tokentwo', res.data.data.token);
			// 		sessionStorage.setItem('refresh', des.encryptByDES(res.data.refresh_token, d));
			// 	}
			// }).catch(err => {
			// 	console.log('err99999', err)
			// })
			return Promise.reject(error.response)
		} else if (error.response.status == '400') {
			if(error.response.data.message!='账号异常,可联系客服咨询！'){
				Toast(error.response.data.message)
			}
			return Promise.reject(error.response)
		} else if (error.response.status == '502') {
			return Toast('服务器错误-502')
		} else {
			if (error.response.data && error.response.data.message && error.response.data.message == '系统维护中，请稍后再试') {
				router.push('/system');
			}
		   Toast(error.response.data.message || error.response.data.reason)
		}
    	return error.response// 返回接口返回的错误信息
		//   return Promise.reject(error);
	}
);

// 错误 回到登录页

function handleErr() {
	sessionStorage.clear();
	//重定向
	router.push('/login');
}

class http {
	static baseURL = baseurl;
	static frontEnd = FrontEnd;

	static promotionUrl() {
		return service.defaults.baseURL;
	}

	static setUrl(str) {
		service.defaults.baseURL = str;
	}

	static post(url, data, conf) {
		let that = this
		return new Promise(function (resolve, reject) {
			let refreshData = {};
			if (sessionStorage.getItem('refresh')) {
				refreshData = {
					refresh_token: des.decryptByDES(sessionStorage.getItem('refresh'), d)
				};
			}
			service
				.post(url, data, conf)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					that.errResponse(err, refreshData, resolve, reject, 'post', url, data)
				});
		});
	}

	static get(url, params) {
		let that = this
		return new Promise(function (resolve, reject) {
			let refreshData = {};
			if (sessionStorage.getItem('refresh')) {
				refreshData = {
					refresh_token: des.decryptByDES(sessionStorage.getItem('refresh'), d)
				};
			}
			service
				.get(url, {params:params})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					that.errResponse(err, refreshData,resolve, reject, 'get', url, params)
				});
		});
	}
	static put(url, data) {
		let that = this
		return new Promise(function (resolve, reject) {
			let refreshData = {};
			if (sessionStorage.getItem('refresh')) {
				refreshData = {
					refresh_token: des.decryptByDES(sessionStorage.getItem('refresh'), d)
				};
			}
			service
				.put(url, data)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					that.errResponse(err, refreshData, resolve, reject, 'put', url, data)
				});
		});
	}

	static delete(url) {
		let that = this
		return new Promise(function (resolve, reject) {
			let refreshData = {};
			if (sessionStorage.getItem('refresh')) {
				refreshData = {
					refresh_token: des.decryptByDES(sessionStorage.getItem('refresh'), d)
				};
			}
			service
				.delete(url)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					that.errResponse(err, refreshData, resolve, reject, 'delete', url)
				});
		});
	}

	static patch(url, data) {
		let that = this
		return new Promise(function (resolve, reject) {
			let refreshData = {};
			if (sessionStorage.getItem('refresh')) {
				refreshData = {
					refresh_token: des.decryptByDES(sessionStorage.getItem('refresh'), d)
				};
			}
			service
				.patch(url, data)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					that.errResponse(err, refreshData, resolve, reject, 'patch', url, data)
				});
		});
	}

	// 请求失败公共方法
	static errResponse(err, refreshData, resolve, reject, type, url, data) {
		console.log(err, refreshData, resolve, reject, type, url, data);
		
		if (err && err.status == 401) {
			//如果token过期，用refresh_token请求新token
			// 修改参数
			let params={
				token:sessionStorage.getItem('tokentwo'),
				refresh:refreshData?.refresh_token
			}
			service.post(refresh_token_api + 'user/public/refresh_token', params).then((res) => {
				console.log(res,'res--');
				
				if (res.data) {
					sessionStorage.setItem('tokentwo', res.data.token);
					sessionStorage.setItem('refresh', des.encryptByDES(res.data.refresh, d));
					//刷新token后重新请求
					if (type === 'get') {
						service.get(url).then((res) => {
							resolve(res.data);
						})
						.catch((err) => {
							reject(err);
						});
					} else if (type === 'post') {
						service.post(url, data).then((res) => {
							resolve(res.data);
						})
						.catch((err) => {
							reject(err);
						});

					} else if (type === 'put') {
						service.put(url, data).then((res) => {
							resolve(res.data);
						})
						.catch((err) => {
							reject(err);
						});
					} else if (type === 'delete') {
						service.delete(url).then((res) => {
							resolve(res.data);
						})
						.catch((err) => {
							reject(err);
						});
					} else if (type === 'patch') {
						service.patch(url, data).then((res) => {
							resolve(res.data);
						}).catch((err) => {
							reject(err);
						});
					}
					//请求完成
				} else {
					console.log('错误');
					
					handleErr();
				}
			})
			.catch((err) => {
				console.log('newhttps:handleErr')
				handleErr();
			});
		} else {
			console.log('进入了');
			
			reject(err);
		}
	}

	static upload(file, pt) {
		var self = this;
		return new Promise(function (resolve, reject) {
			if (pt == 'product' || pt == 'certificate' || pt == 'from' || pt == 'article' || pt == 'activity') {
				var reader = new FileReader();
				reader.fileName = file.name;
				reader.onload = function () {	
					let img = new Image();
					let can = document.createElement('canvas');
					// 读取完成后，将结果复制给img的src
					img.src = this.result;
					img.onload = function () {
						let bytesArray;
						if (img.src.length > 1499990) {
							if (img.width > 1500) {
								var w = 1500 / img.width;
								can.width = 1500;
								can.height = img.height * w;
							} else {
								can.width = img.width;
								can.height = img.height;
							}
							let ctx = can.getContext('2d');
							ctx.drawImage(img, 0, 0, can.width, can.height);
							bytesArray = can.toDataURL('image/jpeg', 0.7);
						} else {
							bytesArray = img.src;
						}
						service
							.post('external/public/upload_files?fn=' + file.name + '&pt=' + pt + '&ut=base64', bytesArray)
							.then((res) => {
								if (res.data.ok) {
									resolve(res.data.data);
								} else {
									Toast({
										message: '权限不足',
										position: 'middle',
										duration: 2000
									});
								}
							})
							.catch((err) => {
								reject(err);
							});
					};
				};
				reader.readAsDataURL(file);
			} else {
				service
					.post('external/public/upload_files?fn=' + file.name, file)
					.then((res) => {
						if (res.data.ok === true) {
							resolve(res.data.data);
						} else {
							Toast({
								message: '权限不足',
								position: 'middle',
								duration: 2000
							});
						}
					})
					.catch((err) => {
						if (err.response.status === 401) {
							Toast({
								message: '权限不足',
								position: 'middle',
								duration: 2000
							});
						} else {
							reject(err);
						}
					});
			}
		});
	}

	static uploadfile(file) {
		var self = this;
		return new Promise(function (resolve, reject) {
			var reader = new FileReader();
			reader.fileName = file.name;
			reader.onload = function () {
				let bytesArray = this.result;
				self
					.post('external/public/upload_files?fn='+
						reader.fileName +
						'&ec=false&ut=base64',
						bytesArray
					)
					.then((res) => {
						if (res.ok == true) {
							resolve(res.data);
						} else {
							reject(res);
						}
					})
					.catch((err) => {
						reject(err);
					});
			};
			reader.readAsDataURL(file);
		});
	}
// ==================== 【最终直通版】upload ====================
// 注意：调用时，如果是视频，建议 pt 传一个非 'from' 的值，或者我们直接在这强制判断


// formData  格式  携带进度条
static newUpload(file, pt, onProgress) {
  const self = this;
  const progressCallback = onProgress || function() {};
  
  return new Promise(function(resolve, reject) {
    const isVideo = file.type.startsWith('video/');
    const isImage = file.type.startsWith('image/');
    
    let timer = null;
    let simulateProgress = 0;
    let isRealProgressStarted = false;
    let requestCompleted = false;

    // 启动模拟进度
    const startFakeProgress = () => {
      progressCallback({ percent: 1 });
      simulateProgress = 1;
      timer = setInterval(() => {
        simulateProgress += Math.random() * 5; // 减慢模拟速度
        if (simulateProgress >= 80) simulateProgress = 80; // 降低上限为80%
        progressCallback({ percent: Math.floor(simulateProgress) });
      }, 300);
    };

    // 结束进度 - 优化版本
    const endProgress = () => {
      requestCompleted = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      // 不是立即到100%，而是逐步增加到100%
      const finalizeProgress = () => {
        if (!isRealProgressStarted && simulateProgress < 100) {
          simulateProgress += 5;
          if (simulateProgress > 100) simulateProgress = 100;
          progressCallback({ percent: Math.floor(simulateProgress) });
          
          if (simulateProgress < 100) {
            setTimeout(finalizeProgress, 100);
          }
        } else {
          progressCallback({ percent: 100 });
        }
      };
      finalizeProgress();
    };

    // 更新进度
    const updateProgress = (percent) => {
      if (timer && percent > 20) { // 真实进度超过20%时再关闭模拟
        clearInterval(timer);
        timer = null;
        isRealProgressStarted = true;
      }
      // 确保进度不倒退
      if (percent > simulateProgress) {
        simulateProgress = percent;
        progressCallback({ percent: Math.floor(simulateProgress) });
      }
    };

    // --- 分支 A：视频或非图片，FormData上传 ---
    if (isVideo || !isImage) {
      startFakeProgress();
      
      const formData = new FormData();
      formData.append('file', file);
      
      // 添加上传开始时间标记
      const uploadStartTime = Date.now();
      
      service
        .post('external/public/upload_files_form_data?fn=' + file.name + '&pt=' + pt + '&ut=base64', formData, {
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              
              // 防止进度提前到100%
              if (percent >= 100) {
                // 如果上传时间太短，可能是计算错误
                const uploadDuration = Date.now() - uploadStartTime;
                if (uploadDuration < 1000 && file.size > 1024 * 1024) { // 大于1MB但1秒内完成
                  percent = 95; // 设为95%，等待服务器确认
                } else if (percent > 99) {
                  percent = 99; // 最高显示99%，等服务器响应
                }
              }
              
              updateProgress(percent);
            } else {
              // lengthComputable为false时，使用估算进度
              if (!isRealProgressStarted) {
                const estimatedProgress = Math.min(80, Math.floor((Date.now() - uploadStartTime) / 100));
                updateProgress(estimatedProgress);
              }
            }
          }
        })
        .then((res) => {
          // 确保有最小处理时间，避免瞬间完成
          const minProcessTime = 500; // 最小处理时间500ms
          const processTime = Date.now() - uploadStartTime;
          
          if (processTime < minProcessTime) {
            setTimeout(endProgress, minProcessTime - processTime);
          } else {
            endProgress();
          }
          
          if (res.data && res.data.ok) resolve(res.data.data);
          else if (res.data) resolve(res.data.data || res.data);
          else resolve(res);
        })
        .catch((err) => {
          console.error('上传接口报错:', err);
          endProgress();
          reject(err);
        });
      return;
    }

    // --- 分支 B：图片压缩上传 ---
    startFakeProgress();
    
    const uploadStartTime = Date.now();
    let imgLoadStartTime = Date.now();

    var reader = new FileReader();
    reader.onload = function(e) {
      const imgLoadTime = Date.now() - imgLoadStartTime;
      // 图片加载后更新进度到30%
      updateProgress(30);
      
      let img = new Image();
      img.onload = function() {
        // 图片解码后更新进度到50%
        updateProgress(50);
        
        let can = document.createElement('canvas');
        let ctx = can.getContext('2d');
        can.width = img.width > 1500 ? 1500 : img.width;
        can.height = img.width > 1500 ? img.height * (1500 / img.width) : img.height;
        ctx.drawImage(img, 0, 0, can.width, can.height);
        
        // 压缩后更新进度到70%
        updateProgress(70);
        
        let bytesArray = can.toDataURL('image/jpeg', 0.7);
        
        // 为图片上传添加模拟进度
        const uploadFakeProgress = setInterval(() => {
          if (simulateProgress < 90) {
            simulateProgress += 2;
            progressCallback({ percent: Math.floor(simulateProgress) });
          }
        }, 200);
        
        service
          .post('external/public/upload_files?fn=' + file.name + '&pt=' + pt + '&ut=base64', bytesArray, {
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable && timer) {
                clearInterval(timer);
                timer = null;
                clearInterval(uploadFakeProgress);
                const percent = 70 + Math.round((progressEvent.loaded * 30) / progressEvent.total);
                updateProgress(Math.min(99, percent));
              }
            }
          })
          .then((res) => {
            clearInterval(uploadFakeProgress);
            
            // 确保总处理时间至少1秒，避免瞬间完成
            const totalTime = Date.now() - uploadStartTime;
            if (totalTime < 1000) {
              setTimeout(endProgress, 1000 - totalTime);
            } else {
              endProgress();
            }
            
            if (res.data && res.data.ok) resolve(res.data.data);
            else resolve(res.data);
          })
          .catch((err) => {
            console.error('图片上传接口报错', err);
            clearInterval(uploadFakeProgress);
            endProgress();
            reject(err);
          });
      };
      
      img.onerror = function() {
        console.error('图片加载失败');
        endProgress();
        reject(new Error('文件解析失败'));
      };
      
      img.src = e.target.result;
    };
    
    reader.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded * 20) / event.total); // 文件读取占20%
        updateProgress(percent);
      }
    };
    
    reader.readAsDataURL(file);
  });
}


// ========== 新增：在http类中添加以下方法 ==========
/**
 * OSS上传文件（适配你的http封装，带完整进度条）
 * @param {File} file 要上传的文件
 * @param {String} pt 上传路径标识
 * @param {Function} onProgress 进度回调函数，参数：{ percent: 数字(0-100), msg: 字符串 }
 * @returns {Promise<String>} 上传后的OSS文件URL
 */
static newUploadOss(file, pt, onProgress) {
  const self = this;
  const progressCallback = onProgress || function() {};
  
  // OSS上传专用axios实例（避免影响全局service）
  const ossAxios = axios.create({
    timeout: 300000, // 5分钟超时
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return new Promise(function(resolve, reject) {
    // 进度控制变量
    let timer = null;
    let simulatePercent = 0;
    let isRealProgress = false;

    // 1. 初始化进度
    const initProgress = () => {
      simulatePercent = 1;
      progressCallback({ percent: simulatePercent, msg: '初始化上传...' });
      // 启动模拟进度（签名请求阶段）
      timer = setInterval(() => {
        if (simulatePercent < 10) { // 签名阶段最多到10%
          simulatePercent += 1;
          progressCallback({ percent: simulatePercent, msg: '获取上传凭证中...' });
        }
      }, 200);
    };

    // 2. 更新真实进度
    const updateRealProgress = (percent, msg = '') => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      isRealProgress = true;
      simulatePercent = percent;
      progressCallback({ 
        percent: Math.min(99, simulatePercent), 
        msg: msg || `上传中 ${simulatePercent}%` 
      });
    };

    // 3. 完成进度
    const completeProgress = () => {
      if (timer) clearInterval(timer);
      progressCallback({ percent: 100, msg: '上传完成' });
    };

    // 4. 失败处理
    const handleFail = (errMsg) => {
      if (timer) clearInterval(timer);
      progressCallback({ percent: 0, msg: errMsg });
      reject(new Error(errMsg));
    };

    // ========== 核心上传逻辑 ==========
    // 第一步：初始化进度
    initProgress();

    // 第二步：获取OSS签名（复用你的get方法，自动处理token刷新）
    self.get(`article/public/uploadsignature?path=${pt}`).then(signRes => {
      if (!signRes || !signRes.host || !signRes.accessid) {
        return handleFail('获取OSS上传凭证失败');
      }

      // 签名获取成功，更新进度到10%
      updateRealProgress(10, '上传凭证获取成功，开始上传文件...');

      // 构建OSS上传参数
      const ossParams = signRes;
      // 拼接文件名（保持和你原有逻辑一致）
      const fileName = ossParams.dir + ossParams.filename + file.name.replace(/.+\./, '.');
      const formData = new FormData();
      
      // OSS必填参数（必须按这个顺序，部分OSS服务端校验顺序）
      formData.append('OSSAccessKeyId', ossParams.accessid);
      formData.append('policy', ossParams.policy);
      formData.append('Signature', ossParams.signature);
      formData.append('key', fileName);
      formData.append('success_action_status', '200'); // 让OSS返回200状态码
      formData.append('file', file);

      // 第三步：OSS直传（核心）
      ossAxios.post(ossParams.host, formData, {
        // 监听上传进度
        onUploadProgress: (e) => {
          if (e.lengthComputable) {
            // 计算进度：签名10% + 上传90%
            const uploadPercent = 10 + Math.round((e.loaded / e.total) * 90);
            updateRealProgress(uploadPercent);
          }
        }
      }).then(() => {
        // OSS上传成功（只要返回200即成功，无需解析响应体）
        completeProgress();
        // 返回完整的OSS文件URL
        resolve(`${ossParams.host}/${fileName}`);
      }).catch(ossErr => {
        handleFail(`文件上传失败：${ossErr.message || '网络错误'}`);
      });

    }).catch(signErr => {
      handleFail(`获取上传凭证失败：${signErr.message || '权限不足'}`);
    });
  });
}
// // ==================== 【最终直通版】uploadfile (保持简单) ====================


}

export default http;
